export const allowedOrigins = ['https://maps.garmin.com'];

/**
 * Checks if the origin is allowed
 * @param {string} origin - The origin to check
 * @returns {boolean}     - True if the origin is allowed, false otherwise
 */
export const isProdOrigin = (origin) => allowedOrigins.includes(origin);
